import { useLanguage } from '@stores/language.store';
import { useQrSummationData } from '@stores/qrSummation.store';
import { useUser } from '@stores/user.store';

export function useScannerPage() {
  const {
    qrError,
    isQrCodeLoading,
    qrMessage,
    fetchQrSummation,
    setError,
    redirectTo,
  } = useQrSummationData();

  const { user, isUserLoading, userError, isEventAvailable } = useUser();

  const { langError, isLangLoading } = useLanguage();

  const errorText = (() => {
    if (qrError && user && user?.lang && qrError[user.lang]) {
      return qrError[user.lang];
    }
    return qrError || userError || langError || '';
  })();

  const showPreloader =
    !errorText &&
    [isUserLoading, isQrCodeLoading, isLangLoading].every(Boolean);

  const isReadyToScan =
    !isUserLoading &&
    !isLangLoading &&
    user &&
    (isEventAvailable || user?.isAdmin);

  return {
    qrMessage,
    fetchQrSummation,
    user,
    isQrCodeLoading,
    showPreloader,
    qrError,
    errorText,
    isReadyToScan,
    setQrError: setError,
    redirectTo,
  };
}
